// News
export { default as News } from "./News";
export type { default as NewsProps } from "./NewsProps.interface";

// NewsCard
export { default as NewsCard } from "./components/NewsCard/NewsCard";
export type { default as NewsCardProps } from "./components/NewsCard/NewsCardProps.interface";